<template>
  <div>
    <h1>FAQs</h1>
  </div>
</template>
<script>
  export default {
    name: 'Faq'
  }
</script>


// WEBPACK FOOTER //
// src/pages/Faq.vue